import Paper from '@base/Paper/Paper';
import styled from '@emotion/styled';
import { Skeleton } from '@material-ui/lab';
import { Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const OuterWrapper = styled(Paper)`
  width: 100%;
  background-color: var(--color-base-1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${boxShadowGenerator()};
`;

const Details = styled.div`
  margin-right: ${Spacings.SPACING_1B};
  width: 70%;
`;

const ActionWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-top: ${Spacings.SPACING_4B};
`;

const StyledDetail = styled.div`
  line-height: 18px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AttemptCountInfo = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${Spacings.SPACING_4B};
`;

const DppCardSkeleton = () => {
  return (
    <OuterWrapper padding={Spacings.SPACING_4B}>
      <Flex>
        <Details>
          <Skeleton variant="text" width="150px" />
          <Skeleton variant="text" width="150px" />

          <StyledDetail $marginTop={Spacings.SPACING_2B}>
            <Skeleton variant="text" width="150px" />
          </StyledDetail>
        </Details>
        <Skeleton variant="circle" width="56px" height="56px" />
      </Flex>

      <ActionWrapper>
        <Skeleton variant="rect" width="100%" height="40px" />
        <AttemptCountInfo>
          <StyledDetail $marginTop={Spacings.SPACING_4B}>
            <Skeleton variant="text" width="150px" />
          </StyledDetail>
        </AttemptCountInfo>
      </ActionWrapper>
    </OuterWrapper>
  );
};

export default DppCardSkeleton;
